import {
  FormControl,
  RadioGroup,
  Stack,
  Radio,
  Text,
  FormLabel,
  Input,
  VStack,
  Button,
} from '@chakra-ui/react'
import { ethers } from 'ethers'
import { useContext, useEffect, useState } from 'react'
import {
  useAccount,
  useContractRead,
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction,
} from 'wagmi'
import { TicTacToeContext } from '../../context/TicTacToeContext'
import TicTacToeABI from '../../assets/constants/abi/TicTacToe.json'
import NetworkMapping from '../../assets/constants/network-mapping.json'

const StartGame = () => {
  const [gameType, setGameType] = useState('NewGame')
  const { address } = useAccount()
  const { setGameDetails, gameDetails } = useContext(TicTacToeContext)
  const [players, setPlayers] = useState({ one: '', two: '', id: '' })

  function setPlayerTwo(address: string) {
    setPlayers({ ...players, two: address })
    if (gameType === 'NewGame') {
      setGameDetails({ ...gameDetails, playerTwo: address })
    }
  }

  function setId(gameId: string) {
    setPlayers({ ...players, id: gameId })
  }

  useEffect(() => {
    if (gameDetails.playerOne !== address) {
      setGameDetails({ ...gameDetails, playerOne: address })
    }
  }, [address])

  const { config, isError: isPrepareError } = usePrepareContractWrite({
    address: NetworkMapping['80001']['TicTacToe'] as `0x${string}`,
    abi: TicTacToeABI,
    functionName: 'createNewGame',
    args: [gameDetails.playerTwo],
    enabled: !!gameDetails.playerTwo && !!gameDetails.playerOne,
  })

  const { data, write: createGame } = useContractWrite(config)

   useWaitForTransaction({
    hash: data?.hash,
    onSuccess(data) {
      let gmId = ethers.utils.formatUnits(data.logs[0].topics[2], 0)
      setGameDetails({ ...gameDetails, gameId: gmId, state: 0 })
    },
  })

  const { refetch } = useContractRead({
    address: NetworkMapping['80001']['TicTacToe'] as `0x${string}`,
    abi: TicTacToeABI,
    functionName: 'getGameDetails',
    args: [players.id],
    enabled: gameDetails.gameId >= 0 && Number(players.id) >= 0,
    onSuccess(gameState: any) {
      setGameDetails({
        ...gameDetails,
        gameId: players.id,
        address: gameState[0],
        playerOne: gameState[1],
        playerTwo: gameState[2],
        state: gameState[3],
        winner: gameState[4],
      })
    },
  })

  function takeAction() {
    if (gameType === 'NewGame') {
      createGame?.()
    } else if (gameType === 'JoinGame') {
      refetch?.()
    }
  }

  return (
    <VStack spacing={'15px'} minW={{ base: 'md', md: 'lg', lg: 'lg' }}>
      <FormControl>
        <RadioGroup onChange={setGameType} value={gameType}>
          <Stack direction="column">
            <Radio size="lg" colorScheme="teal" value="NewGame">
              <Text fontSize={'xl'}>Start Game</Text>
            </Radio>
            <Radio size="lg" colorScheme="teal" value="JoinGame" pt={'md'}>
              <Text fontSize={'xl'}>Join Game</Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </FormControl>
      {gameType === 'JoinGame' && (
        <FormControl>
          <FormLabel color={'teal'} fontWeight="bold">
            Game Id
          </FormLabel>
          <Input
            placeholder="Enter game id"
            _placeholder={{ color: 'gray.500' }}
            type="number"
            onChange={(e) => setId(e.target.value)}
            value={players.id}
            maxW={'md'}
          />
        </FormControl>
      )}
      {gameType === 'NewGame' && (
        <FormControl id="opponent">
          <FormLabel>{`Opponent Address`}</FormLabel>
          <Input
            placeholder="0x1234...5678"
            _placeholder={{ color: 'gray.500' }}
            type="text"
            onChange={(e) => setPlayerTwo(e.target.value)}
            value={players.two}
            maxW={'md'}
          />
        </FormControl>
      )}
      <Button
        colorScheme="teal"
        variant="outline"
        isDisabled={isPrepareError}
        onClick={(e) => {
          e.preventDefault()
          takeAction()
        }}
      >
        {gameType === 'JoinGame' ? 'Continue Game' : 'Start Game'}
      </Button>
    </VStack>
  )
}
export default StartGame
